import { createReducer, on } from '@ngrx/store';
import * as AccountInfoActions from '../actions/account-info.actions';
import { TaxInfo } from '../models';
import { InitReleaseActions } from '../../initiate-and-release/actions';

export const taxesKey = 'taxes';

export interface State extends TaxInfo {}

export const initialTaxState: State = {
  taxPayerId: '',
  withholdFederal: false,
  withholdState: false,
  federalTaxRate: '',
  stateTaxRate: '',
  state: '',
  fedCustomerTaxElections: '',
  stateCustomerTaxElections: '',
  hasStateTax: false
};

export const reducer = createReducer(
  initialTaxState,
  on(AccountInfoActions.loadAccountInfoSuccess, (state, accountInfo) => {
    const { taxes, registrationType } = accountInfo;
    if (registrationType.toLocaleLowerCase().includes('inh')) //resolves gap in IRADetails Service for Inherited IRAs owned by orgs
    {
      return {
        ...state,
        taxPayerId: taxes.taxPayerId,
        withholdFederal: taxes.withholdFederal,
        withholdState: taxes.withholdState,
        state: taxes.state,
      };
    }
    else {
      return {
        ...state,
        taxPayerId: taxes.taxPayerId,
        withholdFederal: taxes.withholdFederal,
        withholdState: taxes.withholdState,
        federalTaxRate: taxes.federalTaxRate,
        stateTaxRate: taxes.stateTaxRate,
        state: taxes.state,
        hasStateTax: taxes.hasStateTax
      };
    }

  }),
  on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, { response }) => {
    return {
      ...state,
      state: response.accountData.stateCd
    }
  }),
  on(AccountInfoActions.loadTransactionsSuccess, (state, response) => {
    const registrationType = response.accountDisplayDetails?.regShortName;
    if (registrationType?.toLocaleLowerCase().includes('inh')) //resolves gap in IRADetails Service for Inherited IRAs owned by orgs
    {
      return {
        ...state,
        fedCustomerTaxElections: response.cashInfo?.cusTaxElections1,
        stateCustomerTaxElections: response.cashInfo?.cusTaxElections2,
        federalTaxRate: response.cashInfo?.cusTaxElections1?.split(' ', 1)[0],
        stateTaxRate: response.cashInfo?.cusTaxElections2?.split(' ', 1)[0],
        hasStateTax: response.iraDetails?.hasStateTax
      }
    }
    else {
      return {
        ...state,
        fedCustomerTaxElections: response.cashInfo?.cusTaxElections1,
        stateCustomerTaxElections: response.cashInfo?.cusTaxElections2,
      }
    }
  }),
  on( AccountInfoActions.loadAccountInfoFailure, AccountInfoActions.loadAccountInfoServiceFailure, AccountInfoActions.loadAccountInfoServiceFailure, () => {
    return initialTaxState;
  }),
  on(AccountInfoActions.updateHeaderTaxRates, (state, { federalTaxRate, stateTaxRate }) => ({
    ...state,
    federalTaxRate,
    stateTaxRate
  }))
);
